import { StepId } from '../../api/useRiskToleranceWorkflowQuery';

export interface FormValues {
  [StepId.TimeHorizon]: number;
}

export const title =
  'Approximately how many years do you expect to continue to invest your assets in the stock market?';

export const options = [
  { label: '0-3 Years', value: 1 },
  { label: '3-5 Years', value: 2 },
  { label: '6-10 Years', value: 3 },
  { label: '11-15 Years', value: 4 },
  { label: '>15 Years', value: 5 },
];
